import { ReactNode } from 'react';

const FeaturePanel = ({ children }: { children: ReactNode }) => {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 sm:gap-x-8 gap-y-10 sm:gap-y-12 sm:max-w-[640px] sm:mx-auto lg:max-w-none lg:mx-0 lg:w-1/2'>
      {children}
    </div>
  );
};

export default FeaturePanel;
